<template>
	<BasePublishCategory v-slot="{item: category}" :seo="true">
		<BasePublishPosts v-slot="{items, nextPage, loadMore, loading}">
			<div class="publish">
				<div class="publish-row1">
					<div class="wider-wrapper">
						<div class="publish-intro-container">
							<CmsBreadcrumbs v-if="category?.breadcrumbs" :items="category.breadcrumbs" />
							
							<h1 v-if="category?.seo_h1">{{category.seo_h1}}</h1>
						</div>
			
						<div v-if="items?.length" class="publish-flex">
							<div class="p-featured">
								<PublishIndexEntry :item="items[0]" mode="big" />
							</div>
							<div class="p-small-featured">
								<BasePublishPostsWidget :fetch="{list_code: 'special_articles', limit: 4, extra_fields: ['short_description'], sort: 'list_position'}" v-slot="{posts: specialArticles}">
									<template v-if="specialArticles?.length">
										<div class="special-articles-list-title">Izdvojene novosti</div>
										<PublishIndexEntry v-for="article in specialArticles" :key="article.id" :item="article" />
									</template>
								</BasePublishPostsWidget>																			
							</div>
						</div>
					</div>
				</div>

				<div class="publish-row2">
					<div class="wider-wrapper">
						<div v-if="items?.length" :id="'items_'+category?.code+'_layout'">
							<div class="p-items blog-cnt" :id="'items_'+category?.code" v-if="items?.length">
								<PublishIndexEntry v-for="post in items.slice(1)" :key="post.id" :item="post" />
							</div>

							<div class="load-more-container" v-if="nextPage">
								<UiLoader v-if="loading" />
								<button v-else type="button" class="btn load-more btn-secondary btn-load-more" @click="loadMore"><BaseCmsLabel code="load_more_publish" /></button>
							</div>
							<BaseUiPagination class="pagination" />
						</div>
						<div v-else><BaseCmsLabel code="no_publish" /></div>
					</div>
				</div>
			</div>
		</BasePublishPosts>
	</BasePublishCategory>
</template>


<style lang="less" scoped>
	.publish{position: relative;}
	.publish-row1{background: url(assets/images/bg-main.jpg); background-size: cover; position: relative; padding: 80px 0 65px; }
	.publish-row2{padding-bottom: 100px;}
	.publish-intro-container{
		h1{
			font-size: 54px; line-height: 70px; position: relative; padding-left: 70px;
			&:before{.icon-contract; position: absolute; display: block; left: 1px; top: 11px; font: 46px/46px var(--fonti); color: var(--primaryColor);}
		}
		.bc{padding-bottom: 8px;}
	}
	.special-articles-list-title{font-size: 30px; line-height: 40px; padding-bottom: 15px; font-weight: 300;}
	.load-more-container{
		text-align: center; padding-top: 15px;
		.btn{min-width: 240px; margin: 0; }
	}
	:deep(.lds-ring){
		div{border-color: var(--primaryColor) transparent transparent transparent;}
	}

	@media (max-width: @l){
		.publish-row2{padding-bottom: 80px;}		
	}

	@media (max-width: @t){
		.publish-row1{padding: 45px 0;}
		.publish-intro-container{
			.bc{padding-bottom: 6px;}
			h1{font-size: 40px; line-height: 52px; padding-left: 55px; padding-top: 0; padding-bottom: 0;
				&:before{top: 8px; font: 35px/35px var(--fonti);}		
			}
		}
		.special-articles-list-title{font-size: 22px; line-height: 30px; padding-bottom: 6px;}

		.publish-row2{padding-bottom: 75px;}
		.load-more-container{
			.btn{min-width: 200px; }
		}		
	}

	@media (max-width: @tp){
		.publish-row1{padding: 22px 0 30px;}
		.publish-intro-container{
			h1{font-size: 36px; line-height: 46px; padding-left: 43px; padding-bottom: 13px;
				&:before{font: 30px/30px var(--fonti); top: 6px;}
			}
		}
		.special-articles-list-title{display: none;}

		.publish-row2{padding-bottom: 60px;}		
	}

	@media (max-width: @m){
		.publish-row1{padding: 38px 0 0;}
		.publish-intro-container{
			.bc{padding-bottom: 5px;}
			h1{font-size: 26px; line-height: 32px; padding-left: 35px; padding-bottom: 15px;
				&:before{font: 24px/24px var(--fonti); top: 3px;}
			}
		}
		.publish-row2{padding-bottom: 45px;}
		.special-articles-list-title{display: block; font-size: 20px; line-height: 26px; padding-bottom: 8px;}

		.load-more-container{
			.btn{min-width: 180px; padding: 0 12px;}
		}		
	}

</style>